import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Tic-Tac-Toe Documentation</p>
    </footer>
  );
}

export default Footer;